import { Input, type InputProps } from '../../Input/Input.js';

export const OpenFormChargeInput = ({ className, prefix, suffix, ...props }: InputProps & { suffix?: string }) => {
  const size = props.readOnly ? 10 : 8;
  return (
    <div className={className}>
      {prefix || null}
      <Input {...props} autoComplete="off" inputMode="decimal" maxLength={size} size={size} type="text" />
      {suffix || null}
    </div>
  );
};
